module.exports = __webpack_public_path__ + "media/BE-Mobile-Video.31abad8d.mp4";